import { ReactElement } from 'react';
import { Component as PlusIcon } from 'icons/icon-ui--plus.svg';
import { Component as MinusIcon } from 'icons/icon-ui--minus.svg';
import styles from './QuantitySelector.module.scss';

type Props = {
  quantity: number;
  onAddQuantity: (updatedQuantity: number) => void;
  onSubtractQuantity: (updatedQuantity: number) => void;
  isPlusDisabled?: boolean;
};

export function QuantitySelector({
  quantity,
  onAddQuantity,
  onSubtractQuantity,
  isPlusDisabled,
}: Props): ReactElement {
  const subtractQuantityHeapId = quantity > 1 ? 'decr_button' : 'rem_button';
  return (
    <div className={styles.container}>
      <button
        type="button"
        className={styles.quantity_button}
        onClick={(event) => {
          event.stopPropagation();
          onSubtractQuantity(quantity - 1);
        }}
        data-heap-id={subtractQuantityHeapId}
      >
        <MinusIcon height="14.5" width="14.5" />
      </button>
      <span className={styles.text}>
        {quantity}
      </span>
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          display: 'flex',
          cursor: isPlusDisabled ? 'default' : 'pointer',
        }}
      >
        <button
          type="button"
          disabled={isPlusDisabled}
          style={isPlusDisabled ? {
            cursor: 'default',
          } : {}}
          className={styles.quantity_button}
          onClick={(event) => {
            event.stopPropagation();
            onAddQuantity(quantity + 1);
          }}
          data-heap-id="incr_button"
        >
          <PlusIcon height="14.5" width="14.5" />
        </button>
      </div>
    </div>
  );
}
